/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IGVKennungRequest
 */
export interface IGVKennungRequest {
    /**
     * 
     * @type {number}
     * @memberof IGVKennungRequest
     */
    igvKennziffer?: number;
    /**
     * 
     * @type {string}
     * @memberof IGVKennungRequest
     */
    accessCode?: string | null;
}

/**
 * Check if a given object implements the IGVKennungRequest interface.
 */
export function instanceOfIGVKennungRequest(value: object): value is IGVKennungRequest {
    return true;
}

export function IGVKennungRequestFromJSON(json: any): IGVKennungRequest {
    return IGVKennungRequestFromJSONTyped(json, false);
}

export function IGVKennungRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IGVKennungRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'igvKennziffer': json['igvKennziffer'] == null ? undefined : json['igvKennziffer'],
        'accessCode': json['accessCode'] == null ? undefined : json['accessCode'],
    };
}

export function IGVKennungRequestToJSON(json: any): IGVKennungRequest {
    return IGVKennungRequestToJSONTyped(json, false);
}

export function IGVKennungRequestToJSONTyped(value?: IGVKennungRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'igvKennziffer': value['igvKennziffer'],
        'accessCode': value['accessCode'],
    };
}

